import { render } from "./ManagerRolesView.vue?vue&type=template&id=2cb41e7a"
import script from "./ManagerRolesView.vue?vue&type=script&lang=js"
export * from "./ManagerRolesView.vue?vue&type=script&lang=js"

import "./ManagerRolesView.vue?vue&type=style&index=0&id=2cb41e7a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__